import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { FeatureFlag } from "../../common/posthog";
import { AITransparencyLink } from "../../components/AITransparencyLink";
import { PRODUCT_NAME } from "../../utils/terminology";
import { navigationConfig } from "./navigation.config";

export const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <List>
        {navigationConfig.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          const navItem = (
            <ListItem key={item.path} disablePadding>
              <ListItemButton
                selected={isActive}
                onClick={() => navigate(item.path)}
              >
                <ListItemIcon>
                  <Icon color={isActive ? "primary" : "inherit"} />
                </ListItemIcon>
                <ListItemText primary={item.title} />
              </ListItemButton>
            </ListItem>
          );

          if (!item.featureFlag) {
            return navItem;
          }

          return (
            <FeatureFlag
              key={item.path}
              flag={item.featureFlag}
              fallback={null}
            >
              {navItem}
            </FeatureFlag>
          );
        })}
      </List>
      <Box
        sx={{
          position: "absolute",
          bottom: 2,
          left: 0,
          right: 0,
          textAlign: "center",
          p: 1
        }}
      >
        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
          {PRODUCT_NAME} (Preview)
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
          AI can make mistakes. <AITransparencyLink />
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
          © Copyright 2025 Spoke Network, Inc.
        </Typography>
      </Box>
    </>
  );
};
